
namespace RedBullMOBILE360.SMSCodes {

    @Serenity.Decorators.registerClass()
    export class InformativeSmsDialog extends Serenity.EntityDialog<InformativeSmsRow, any> {
        protected getFormKey() { return InformativeSmsForm.formKey; }
        protected getIdProperty() { return InformativeSmsRow.idProperty; }
        protected getLocalTextPrefix() { return InformativeSmsRow.localTextPrefix; }
        protected getNameProperty() { return InformativeSmsRow.nameProperty; }
        protected getService() { return InformativeSmsService.baseUrl; }
        protected getDeletePermission() { return InformativeSmsRow.deletePermission; }
        protected getInsertPermission() { return InformativeSmsRow.insertPermission; }
        protected getUpdatePermission() { return InformativeSmsRow.updatePermission; }

        protected form = new InformativeSmsForm(this.idPrefix);

    }
}